import { useCountRemainingVehicle } from './useCountRemainingVehicle'

export function useCanAddNewVehicle(isLoading: boolean) {
  const remainingVehicleCount = useCountRemainingVehicle()
  return remainingVehicleCount > 0 && !isLoading
}
